module.exports = __webpack_public_path__ + "img/yellow-icon-en(3).780ca8bd.png";